export const itemTypeOptions = [
  { label: "EGS", value: "EGS" },
  { label: "GS1", value: "GS1" },
];
